import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { Category } from 'src/types/catalog';
import { TreeViewItem } from 'src/types/TreeView';
import axiosInstance from 'src/utils/axios';
import { transformCategoriesToTreeData } from 'src/utils/transformCategoriesToTreeData';

const useGetCategoryQuery = (catalogId: number | null): UseQueryResult<TreeViewItem[]> =>
  useQuery<TreeViewItem[]>({
    queryKey: queryKeys.product.categories(catalogId),
    queryFn: async (): Promise<TreeViewItem[]> => {
      if (catalogId) {
        const url: string = api.getCatalogCategories(catalogId!);
        const res = await axiosInstance.get<Category[]>(url);
        const categories: Category[] = res.data;
        const transformedCategories: TreeViewItem[] = transformCategoriesToTreeData(categories);

        return transformedCategories;
      }
      throw new Error(`Invalid catalogId: "${catalogId}"`);
    },
    enabled: false,
  });

export default useGetCategoryQuery;
